import { render, staticRenderFns } from "./IndexCalculator.vue?vue&type=template&id=0a216f06&"
import script from "./IndexCalculator.vue?vue&type=script&lang=js&"
export * from "./IndexCalculator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports